<div *ngIf="profitabilityEvaluationParameters">
    <h2 class="_sansSerif _primary"[i18nKey]="'evaluations.profitability.criteria.title'"></h2>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <h3 [i18nKey]="'evaluations.profitability.criteria.marks.depending.on.standard.rates'"></h3>
    <kiwi-spacer [size]="8"></kiwi-spacer>

    <form #profitabilityMarkCriteriaForm="ngForm" (ngSubmit)="save()" kiwiProfitabilityCriteriaRatesValidator>
        <div class="grid-x grid-margin-x grid-margin-y">
            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.profitability.criteria.minimal.mark.profitability.rate'"></span>
                <kiwi-percentage-input
                    (change)="onValueUpdate()"
                    name="minimalMarkProfitabilityRate"
                    [(ngModel)]="profitabilityEvaluationParameters.minimalMarkProfitabilityRate"
                    [class._orderError]="profitabilityMarkCriteriaForm.errors?.rateOrder"
                    required>
                </kiwi-percentage-input>
            </label>

            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.profitability.criteria.average.mark.profitability.rate'"></span>
                <kiwi-percentage-input (change)="onValueUpdate()"
                                       name="averageMarkProfitabilityRate"
                                       [(ngModel)]="profitabilityEvaluationParameters.averageMarkProfitabilityRate"
                                       [class._orderError]="profitabilityMarkCriteriaForm.errors?.rateOrder"
                                       required>
                </kiwi-percentage-input>
            </label>

            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.profitability.criteria.maximal.mark.profitability.rate'"></span>
                <kiwi-percentage-input (change)="onValueUpdate()"
                                       name="maximalMarkProfitabilityRate"
                                       [(ngModel)]="profitabilityEvaluationParameters.maximalMarkProfitabilityRate"
                                       [class._orderError]="profitabilityMarkCriteriaForm.errors?.rateOrder"
                                       required>
                </kiwi-percentage-input>
            </label>
        </div>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <div *ngIf="profitabilityMarkCriteriaForm.errors?.rateOrder" class="alertMessage _error">
            <i class="fas fa-exclamation-triangle alertMessage-icon"></i>
            <span class="alertMessage-text"[i18nKey]="'evaluations.profitability.criteria.rate.order.error'"></span>
        </div>

        <kiwi-spacer [size]="24"></kiwi-spacer>

        <h3 [i18nKey]="'evaluations.profitability.criteria.marks.depending.on.competition'"></h3>
        <kiwi-spacer [size]="8"></kiwi-spacer>

        <div class="grid-x grid-margin-x grid-margin-y">
            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.profitability.criteria.mark.depending.on.standard.rates.weight'"></span>
                <kiwi-number-input (change)="onValueUpdate()"
                                   name="markDependingOnStandardRatesWeight"
                                   [min]="profitabilityEvaluationParameters.minMarkDependingOnStandardRatesWeight"
                                   [max]="profitabilityEvaluationParameters.maxMarkDependingOnStandardRatesWeight"
                                   [(ngModel)]="profitabilityEvaluationParameters.markDependingOnStandardRatesWeight"
                                   required>
                </kiwi-number-input>
            </label>

            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.profitability.criteria.mark.depending.on.competition.weight'"></span>
                <kiwi-number-input (change)="onValueUpdate()"
                                   name="markDependingOnCompetitionWeight"
                                   [min]="profitabilityEvaluationParameters.minMarkDependingOnCompetitionWeight"
                                   [max]="profitabilityEvaluationParameters.maxMarkDependingOnCompetitionWeight"
                                   [(ngModel)]="profitabilityEvaluationParameters.markDependingOnCompetitionWeight"
                                   required>
                </kiwi-number-input>
            </label>
        </div>

        <kiwi-spacer [size]="32"></kiwi-spacer>

        <div class="grid-x align-center">
            <button class="cell shrink button"
                    type="submit"
                    name="saveProfitabilityMarkCriteria"
                    [disabled]="profitabilityMarkCriteriaForm.invalid"[i18nKey]="'common.action.save'"></button>
        </div>
    </form>

</div>
